<div class="view-content analysis-component">
  @if (!activeExpeditionId) {
    <div class="no-browser-session-hint">
      <fa-icon [icon]="faExclamationCircle"></fa-icon>
      No active browser session.
      <wm-start-browser-session-action></wm-start-browser-session-action>
    </div>
  }
  @if (!!activeExpeditionId) {
    <div>
      <div class="analysis-content">
        <button pButton class="analysis-button" icon="true" [disabled]="!activeExpeditionId" label="Start Tab-Order Analysis" (click)="analyzeLink()">
          <fa-icon [icon]="faSparkles" class="icon"></fa-icon>
        </button>
        <div class="analysis-settings">
          <div class="analysis-mode">
            <p-selectButton
              [options]="stateOptions"
              [disabled]="!resultsPublished"
              optionLabel="label"
              optionValue="value"
              [(ngModel)]="tabView"
              (onChange)="toggleUserChoice($event.value)">
              <ng-template let-item pTemplate="item">
                <span [pTooltip]="item.tooltip" tooltipPosition="top" tooltipEvent="hover">
                  {{ item.label }}
                </span>
              </ng-template>
            </p-selectButton>
          </div>
          @if (resultsPublished) {
            <button pButton
              class="connector-lines-toggle"
              [pTooltip]="showConnectorLines ? 'Hide connector lines' : 'Show connector lines'"
              tooltipPosition="top"
              (click)="toggleConnectorLines()">
              <fa-icon [icon]="showConnectorLines ? faEye : faEyeSlash"></fa-icon>
            </button>
          }
        </div>
    </div>
    @if (showResultsPending && progressState && !errorMsg) {
      <div class="info-container">
        <div class="card flex justify-content-center">
          <p-progressSpinner strokeWidth="3" ariaLabel="loading"></p-progressSpinner>
        </div>
        <label class="loading-text">Loading...</label>
        <div class="loading-progress-bar-container">
          <div class="loading-progress-bar"></div>
        </div>
        <div class="status-text">
          <span class="progress-msg">{{ progressState.msg }}</span>
          <span class="time-remaining">{{ progressState.time }}</span>
        </div>
      </div>
    }
    <!-- Observations Summary Row -->
    @if (resultsPublished && !errorMsg) {
      <div class="observations-summary">
        <div class="observation-stats">
          <label class="total">Observations</label>
        </div>
      </div>
    }
    <!-- Observations list-->
    @if (resultsPublished && !errorMsg) {
      <div>
        @if (!userchoice) {
          <p-accordion class="observation-list" >
            <p-accordionTab header="Elements in Sequential Focus" [selected]="!userchoice">
              <p-accordion class="observation-list flex"
                (activeIndexChange)="onActiveIndexChange($event)">
                @if (resultsPublished && !userchoice && tabObservationsList.length == 0) {
                  <div class="no-observation-details">
                    No Observations Detected
                  </div>
                }
                @for (observation of tabObservationsList; track observation; let i = $index) {
                  <p-accordionTab
                    >
                    <ng-template pTemplate="header" >
                      <span class="observation-caption" >
                        {{i+1}}
                        {{observation.tagName ? (observation.tagName | titlecase) : ''}}
                        @if (observation.text) {
                          <span>
                            - {{ observation.text ? (observation.text | titlecase) : ''  }}
                          </span>
                        }
                      </span>
                    </ng-template>
                    <ng-template pTemplate="content">
                      <div class="observation-details">
                        @if (observation.tabIndex) {
                          <div class="details-row">
                            <label class="title">TabIndex: </label>
                            "{{ observation.tabIndex }}"
                          </div>
                        }
                        @if (observation.focusIndicator) {
                          <div class="details-row">
                            <label class="title">Focus Indicator: </label>
                            "{{ observation.focusIndicator }}"
                          </div>
                        }
                        @if (observation.cssSelector) {
                          <div class="details-row">
                            <label class="title">Selector: </label>
                            <div class="target">
                              <pre><code>"{{ observation.cssSelector }}"</code></pre>
                            </div>
                          </div>
                        }
                        @if (observation.className) {
                          <div class="details-row">
                            <label class="title">HTML: </label>
                            <div class="target">
                              <pre><code> "{{ observation.className }}"</code></pre>
                            </div>
                          </div>
                        }
                      </div>
                    </ng-template>
                  </p-accordionTab>
                }
              </p-accordion>
            </p-accordionTab>
          </p-accordion>
        }
        @if (userchoice) {
          <p-accordion class="observation-list" >
            <p-accordionTab  header="Elements in Sequential Focus">
              <p-accordion class="observation-list flex"
                (activeIndexChange)="onActiveIndexChange($event)">
                @if (resultsPublished && userchoice && includedObservationsList.length == 0) {
                  <div class="no-observation-details">
                    No Observations Detected
                  </div>
                }
                @for (observation of includedObservationsList; track observation; let i = $index) {
                  <p-accordionTab >
                    <ng-template pTemplate="header">
                      <span class="observation-caption">
                        {{i+1}}
                        {{observation.nodeName ? (observation.nodeName | titlecase) : ''}}
                        @if (observation.text) {
                          <span>
                            - {{ observation.text ? (observation.text | titlecase) : ''  }}
                          </span>
                        }
                      </span>
                    </ng-template>
                    <ng-template pTemplate="content">
                      <div class="observation-details">
                        @if (observation.tabIndex) {
                          <div class="details-row">
                            <label class="title">TabIndex: </label>
                            "{{ observation.tabIndex }}"
                          </div>
                        }
                        @if (observation.cssSelector) {
                          <div class="details-row">
                            <label class="title">Selector: </label>
                            <div class="target">
                              <pre><code>"{{ observation.cssSelector }}"</code></pre>
                            </div>
                          </div>
                        }
                      </div>
                    </ng-template>
                  </p-accordionTab>
                }
              </p-accordion>
            </p-accordionTab>

            <p-accordionTab  header="Violations">
              <p-accordion class="observation-list flex">
                @if (resultsPublished && !userchoice && violationsList.length == 0){
                  No Observations Detected
                }
                @for (entry of violationsList; track entry; let i = $index) {
                <p-accordionTab>
                  <ng-template pTemplate="header">
                                  <span class="observation-caption">
                                    {{ entry.violationString }}
                                    <span class="violation-count">({{ entry.details.length }})</span>
                                  </span>
                  </ng-template>
                  <ng-template pTemplate="content">
                    <p-accordion>
                      @for(observation of entry.details; track observation; let j= $index){
                      <p-accordionTab>
                        <ng-template pTemplate="header">
                                      <span class="observation-caption">
                                      {{j+1}}
                                        {{observation.nodeName ? (observation.nodeName | titlecase) : ''}}
                                        @if (observation.text){
                                             - {{ observation.text ? (observation.text | titlecase) : ''  }}
                                        }
                                    </span>
                        </ng-template>
                        <ng-template pTemplate="content">
                          <div class="observation-details">
                            <div class="details">
                              <div class="form-section-content flex">
                                @if (observation.description) {
                                  <div class="form-item">
                                    <label class="form-label blue">Description</label>
                                    <div class="description">{{ observation.description }}</div>
                                  </div>
                                }
                                @if (observation.wcagCriterion) {
                                  <div class="form-item">
                                    <label class="form-label blue">WCAG Mapping</label>
                                    <div class="wcag-mapping">
                                      <div class="wcag-label">{{ observation.wcagCriterion }}</div>
                                      @if (observation.wcagLevel) {
                                        <div class="wcag-label">Level {{ observation.wcagLevel }}</div>
                                      }
                                    </div>
                                  </div>
                                }
                                @if (observation.impact) {
                                  <div class="form-item">
                                    <label class="form-label blue">Impact</label>
                                    <div class="description">{{ observation.impact | titlecase }}</div>
                                  </div>
                                }
                                @if (observation.tabIndex) {
                                  <div class="form-item">
                                    <label class="form-label blue">TabIndex</label>
                                    <div class="description">{{ observation.tabIndex }}</div>
                                  </div>
                                }
                                @if (observation.focusIndicator) {
                                  <div class="form-item">
                                    <label class="form-label blue">Focus Indicator</label>
                                    <div class="description">{{ observation.focusIndicator }}</div>
                                  </div>
                                }
                                @if (observation.cssSelector) {
                                  <div class="form-item">
                                    <label class="form-label blue">Selector</label>
                                    <div class="target">
                                      <pre><code>{{ observation.cssSelector }}</code></pre>
                                    </div>
                                  </div>
                                }
                                @if (observation.screenshotId) {
                                  <div class="screenshot form-item">
                                    <label class="form-label blue">Screenshot</label>
                                    <wm-image [imageId]="observation.screenshotId" [allowToOpenScreenshotToolInPopup]="true"></wm-image>
                                  </div>
                                }
                              </div>
                              <div class="actions">
                                <button
                                        pButton
                                        class="add-to-finding-btn"
                                        [ngClass]="{ 'open-finding': addedToFinding }"
                                        (click)="addedToFinding ? openFinding() : addNewFinding(entry.violationString, observation)">
                                  <img class="add-finding-icon" src="assets/img/corpus-delicti.svg"/>
                                  {{ addedToFinding ? 'Open Finding' : 'Add to Finding' }}
                                </button>
                              </div>
                            </div>
                          </div>
                        </ng-template>
                      </p-accordionTab>
                      }
                    </p-accordion>
                  </ng-template>
                </p-accordionTab>
                }
              </p-accordion>
            </p-accordionTab>

            <p-accordionTab header="Compliant">
              <p-accordion class="observation-list flex">
                @if (resultsPublished && compliantList.length == 0){
                  No Compliant Results Detected
                }
                @for (entry of compliantList; track entry; let i = $index) {
                <p-accordionTab>
                  <ng-template pTemplate="header">
                                  <span class="observation-caption">
                                    {{ entry.compliantString }}
                                    <span class="violation-count">({{ entry.details.length }})</span>
                                  </span>
                  </ng-template>
                  <ng-template pTemplate="content">
                    <p-accordion>
                      @for(observation of entry.details; track observation; let j= $index){
                      <p-accordionTab>
                        <ng-template pTemplate="header">
                                      <span class="observation-caption">
                                      {{j+1}}
                                        {{observation.nodeName ? (observation.nodeName | titlecase) : ''}}
                                        @if (observation.text){
                                             - {{ observation.text ? (observation.text | titlecase) : ''  }}
                                        }
                                    </span>
                        </ng-template>
                        <ng-template pTemplate="content">
                          <div class="observation-details">
                            <div class="details">
                              <div class="form-section-content flex">
                                @if (observation.description) {
                                  <div class="form-item">
                                    <label class="form-label blue">Description</label>
                                    <div class="description">{{ observation.description }}</div>
                                  </div>
                                }
                                @if (observation.wcagCriterion) {
                                  <div class="form-item">
                                    <label class="form-label blue">WCAG Mapping</label>
                                    <div class="wcag-mapping">
                                      <div class="wcag-label">{{ observation.wcagCriterion }}</div>
                                      @if (observation.wcagLevel) {
                                        <div class="wcag-label">Level {{ observation.wcagLevel }}</div>
                                      }
                                    </div>
                                  </div>
                                }
                                @if (observation.focusIndicator) {
                                  <div class="form-item">
                                    <label class="form-label blue">Focus Indicator</label>
                                    <div class="description">{{ observation.focusIndicator }}</div>
                                  </div>
                                }
                                @if (observation.tabIndex) {
                                  <div class="form-item">
                                    <label class="form-label blue">TabIndex</label>
                                    <div class="description">{{ observation.tabIndex }}</div>
                                  </div>
                                }
                                @if (observation.cssSelector) {
                                  <div class="form-item">
                                    <label class="form-label blue">Selector</label>
                                    <div class="target">
                                      <pre><code>{{ observation.cssSelector }}</code></pre>
                                    </div>
                                  </div>
                                }
                                @if (observation.screenshotId) {
                                  <div class="screenshot form-item">
                                    <label class="form-label blue">Screenshot</label>
                                    <wm-image [imageId]="observation.screenshotId" [allowToOpenScreenshotToolInPopup]="true"></wm-image>
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                        </ng-template>
                      </p-accordionTab>
                      }
                    </p-accordion>
                  </ng-template>
                </p-accordionTab>
                }
              </p-accordion>
            </p-accordionTab>


        </p-accordion>
      }
    </div>
  }
  <!-- Error message display -->
  @if (errorMsg) {
    <div class="error-container">
      <fa-icon [icon]="faTimesCircle" class="error-icon"></fa-icon>
      <span class="error-message">{{ errorMsg }}</span>
    </div>
  }
</div>
}
</div>












